import { parseFeatureAdOffer } from 'helpers/featuredAd.helpers';
import { useEventHandler } from 'hook/event.hook';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { NATIVE_AD } from 'types/morph.pagePosition.constants';
import NativeAdView from 'partial/OfferManager/modules/NativeAdModule/NativeAdView';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

const NativeAdController = props => {
  const { offers, modulePosition } = props;
  const isRenderedOnFactor =
    offers[0]?.location === 'ACCOUNT_MIX' &&
    (offers[0]?.position === 'BOTTOM' || offers[0]?.position === 'TOP');
  const featuredAdOffer = offers && parseFeatureAdOffer(offers[0]);

  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: NATIVE_AD,
    modulePosition: modulePosition,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  const eventHandler = useEventHandler();
  return (
    <FlexContainer className={'flex-column'}>
      {seenModuleTracking}
      <NativeAdView
        modulePosition={modulePosition}
        featuredAdOffer={featuredAdOffer}
        eventHandler={eventHandler}
        isRenderedOnFactor={isRenderedOnFactor}
      />
    </FlexContainer>
  );
};

export default NativeAdController;
